module.exports = __webpack_public_path__ + "static/media/YF98_4.0c71a1a4.jpg";